module.exports = __webpack_public_path__ + "static/media/4.a0d7f320.png";